"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localized_strings_1 = __importDefault(require("localized-strings"));
const locales = new localized_strings_1.default({
    en: {
        siren: '**Registration number**: {siren}',
        vatId: '**VAT**: {vatId}',
    },
    fr: {
        siren: '**SIREN** : {siren}',
        vatId: '**TVA** : {vatId}',
    },
});
exports.default = locales;
